import { createAction, props } from '@ngrx/store';

export const mobileViewMaxScreenWidth = 834;

export const setMobileViewMode = createAction('[AppConfig] Set Mobile View Mode', props<{ mobileViewMode: boolean }>());

